import React, { Component } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import axios from "axios";
import CommonToast from "../Toaster/CommonToast";

export default class PfUpload extends Component {

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      uploading: false,
      displayUploadedPfDocument: [],
      successMessage: '',
      completed: '',
      hasError: "",
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    };
  }
  handlePfDocumentsChange = (event) => {
    this.setState({ documents: Array.from(event.target.files) });
  };

  componentDidMount() {
    const { userId } = this.props;
    this.fetchEmployeePfDocuments(userId)
  }

  fetchEmployeePfDocuments = (id) => {
    axios({
      method: 'get',
      url: `document/documents/${id}/o`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        console.log("res data is here*** ", res);
        this.setState({
          displayUploadedPfDocument: res.data.documents
        })
      })
      .catch(err => {
        console.log("error is here", err)
      })
  }

  uploadPfDocuments = async () => {
    const { userId } = this.props;
    const { documents } = this.state;
    if (!userId || documents.length === 0) return;
    try {
      this.setState({ uploading: true });
      for (const document of documents) {
        const formData = new FormData();
        formData.append("document", document);
        formData.append("type", "o");
        const res = await axios.post(`document/upload/esicpf/${userId}`, formData);
        console.log("res?.data?.message===========>", res?.data?.message);
        this.setState({
          uploadingStatus: res?.data?.message,
          completed: true,
          toastMessage: res?.data?.message,
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        })
      }

      this.fetchEmployeePfDocuments(userId)
    } catch (error) {
      this.setState({
        uploadingStatus: "Uploading documents Failed",
        hasError: true,
        toastMessage: "Uploading documents Failed",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      })
      alert("Error uploading documents.");
    } finally {
      this.setState({ uploading: false });
    }
  };

  deleteDocumentForPf = (docId, index) => {
    const { userId } = this.props;
    axios({
      method: 'delete',
      url: `document/documents/${userId}/${docId}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then((response) => {
        const updatedPfDocuments = [...this.state.displayUploadedPfDocument];
        updatedPfDocuments.splice(index, 1);
        this.setState({
          displayUploadedPfDocument: updatedPfDocuments,
          uploadingStatus: response.data.message,
          toastMessage: response.data.message,
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        });
      })
      .catch(err => {
        this.setState({
          hasError: true,
          toastMessage: "Error deleting document",
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ showToast: false });
        }, 900);
        console.error("Error deleting document:", err);
      });
  }

  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <div className="row">
          {/* {this.state.hasError ? (
            <Alert variant="outline-danger" className="m-3" block>
              {this.state.uploadingStatus}
            </Alert>
          ) : this.state.completed ? (
            <Alert variant="outline-success" className="m-3" block>
              {this.state.uploadingStatus}
            </Alert>
          ) : (
            <></>
          )} */}
        </div>
        <Card className="mb-3">
          {this.state.successMessage && (
            <div className="alert alert-success">
              {this.state.successMessage}
            </div>
          )}
          <Card.Body>
            <Form.Group>
              <Form.Label>Upload ESIC/PF Documents</Form.Label>
              <Form.Control type="file" multiple accept=".pdf,.doc,.docx,.jpg,.png" onChange={this.handlePfDocumentsChange} />
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary mt-2" onClick={this.uploadPfDocuments} disabled={this.state.uploading}>
                {this.state.uploading ? "Uploading..." : "Upload Pf Documents"}
              </Button>
            </Form.Group>
          </Card.Body>
          <table className="image-table">
            <thead>
              <tr>
                <th>Image/Pdf</th>
                <th>Actions</th>
              </tr>
            </thead>
            {/* <tbody>
              {this.state.displayUploadedPfDocument && this.state.displayUploadedPfDocument.length > 0 ? (
                this.state.displayUploadedPfDocument.map((doc, index) => {
                  const filePath = doc?.documentPath?.toLowerCase();
                  const isPdf = filePath?.endsWith(".pdf");
                  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);

                  return (
                    <tr key={index}>
                      <td>
                        {isPdf ? (
                          <a href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank" rel="noopener noreferrer">
                            <Button variant="outline-info" size="sm">📄 View PDF</Button>
                          </a>
                        ) : isImage ? (
                          <img src={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            alt={`Uploaded ${index}`} className="document-image" />
                        ) : (
                          <span>Unsupported File Format</span>
                        )}
                      </td>
                      <td>
                        <Button size="sm" onClick={() => this.deleteDocumentForPf(doc.id, index)} variant="outline-danger">
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="2">No documents available to display.</td>
                </tr>
              )}
            </tbody> */}

            {/* start */}
            <tbody>
              {this.state.displayUploadedPfDocument && this.state.displayUploadedPfDocument.length > 0 ? (
                this.state.displayUploadedPfDocument.map((doc, index) => {
                  const filePath = doc?.documentPath?.toLowerCase();
                  const isPdf = filePath?.endsWith(".pdf");
                  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
                  const isDocx = filePath?.endsWith(".docx") || filePath?.endsWith(".doc");
                  const isTxt = filePath?.endsWith(".txt");

                  return (
                    <tr key={index}>
                      <td>
                        {isPdf ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button variant="outline-info" size="sm">📄 View PDF</Button>
                          </a>
                        ) : isImage ? (
                          <img
                            src={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            alt={`Uploaded ${index}`}
                            className="document-image"
                            style={{ width: "100px", height: "auto" }}
                          />
                        ) : isDocx ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                          >
                            <Button variant="outline-primary" size="sm">📑 Download DOCX</Button>
                          </a>
                        ) : isTxt ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_URL}/${doc.documentPath}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                          >
                            <Button variant="outline-secondary" size="sm">📄 Download TXT</Button>
                          </a>
                        ) : (
                          <span>Unsupported File Format</span>
                        )}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          onClick={() => this.deleteDocumentForPf(doc.id, index)}
                          variant="outline-danger"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="2">No documents available to display.</td>
                </tr>
              )}
            </tbody>

            {/* end */}
          </table>
        </Card >
      </>
    );
  }
}
